import BaseMystery from '../BaseMystery'

const FirstSorrow = () => {
	const imagesList = [
		"https://www.wga.hu/art/r/rembrand/11biblic/04newtes.jpg",
	];

	const titleText = "The Prophecy of Simeon";
	const scriptureQuote = "\"Behold, this child is destined for the fall and rise of many in Israel, and to be a sign that will be contradicted (and you yourself a sword will pierce) ...\"";
	const scriptureCitation = "Luke 2:34-35 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Luke%202%3A22-35&version=NABRE";

	return (
		<BaseMystery titleText={titleText}
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default FirstSorrow;